import { render, staticRenderFns } from "./theme.page.vue?vue&type=template&id=60418861&scoped=true&"
import script from "./theme.page.vue?vue&type=script&lang=js&"
export * from "./theme.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60418861",
  null
  
)

export default component.exports